import { render, staticRenderFns } from "./order-finish.vue?vue&type=template&id=a4fc7e46&scoped=true&"
import script from "./order-finish.vue?vue&type=script&lang=js&"
export * from "./order-finish.vue?vue&type=script&lang=js&"
import style0 from "./order-finish.vue?vue&type=style&index=0&id=a4fc7e46&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4fc7e46",
  null
  
)

export default component.exports